/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react';
import {useIntl} from 'react-intl';
import {PageTitle} from '_metronic/layout/core';
import {
  MixedWidget2,
  // MixedWidget10,
  // MixedWidget11,
  // ListsWidget2,
  // ListsWidget3,
  // ListsWidget4,
  // ListsWidget5,
  ListsWidget6, MixedWidget11,
  // TablesWidget5,
  // TablesWidget10,
  // MixedWidget8,
} from '_metronic/partials/widgets';
import Filter from "./Filter";
export interface IFormValue {fromDate: string | undefined, toDate: string | undefined}

const DashboardWrapper: FC = () => {
  const intl = useIntl();
  const [formValue, setformValue] = useState<IFormValue>({ fromDate: undefined, toDate: undefined });
  const handleSubmit = (fromDate: string | undefined, toDate: string | undefined) => {
    console.log(fromDate,toDate)
    setformValue({ fromDate: fromDate, toDate: toDate })
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <>
        <Filter handleSubmit={handleSubmit}/>
        {/* begin::Row */}
        <div className='row gy-5 g-xl-10 h-100'>
          <div className='col-xxl-3'>
            <MixedWidget2
                formValue={formValue}
                className='card-xl-stretch'
            />
          </div>
          <div className='col-xxl-4'>
            <ListsWidget6 className='card-xl-stretch ' formValue={formValue}/>
          </div>
          {/*<div className='col-xxl-4'>*/}
          {/*  <ListsWidget5 className='card-xxl-stretch' />*/}
          {/*</div>*/}
          <div className='col-xxl-5'>
            {/*<MixedWidget10
          className='card-xxl-stretch'
          chartColor='primary'
          chartHeight='400px'
        />*/}
            <MixedWidget11
                formValue={formValue}
                className='card-xxl-stretch'
                chartColor='primary'
                chartHeight='450px'
            />
          </div>
        </div>
        {/* end::Row */}


      </>
    </>
  );
};

export {DashboardWrapper};
